var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("toast", { ref: "toast" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("work-menu"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pt-3",
              class: {
                "col-12": _vm.$window.isSP,
                "col-md-10": _vm.$window.isPC
              }
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v("年")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedYear,
                        expression: "selectedYear"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "year" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedYear = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l(_vm.yearList, function(year) {
                    return _c(
                      "option",
                      { key: year, domProps: { value: year } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(year) +
                            "\n                  "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("label", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v("月")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedMonth,
                        expression: "selectedMonth"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "month" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedMonth = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l(12, function(month) {
                    return _c(
                      "option",
                      { key: month, domProps: { value: month } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(month) +
                            "\n                  "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v("労働時間単位")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedInterval,
                        expression: "selectedInterval"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "interval" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedInterval = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l([0, 15, 30, 60], function(interval) {
                    return _c(
                      "option",
                      { key: interval, domProps: { value: interval } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(interval) +
                            "\n                  "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("label", [_vm._v("ユーザ")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedUserId,
                        expression: "selectedUserId"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "shiftId" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedUserId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l(_vm.userList, function(user) {
                    return !_vm.isRetiree(user.deletedAt)
                      ? _c(
                          "option",
                          {
                            key: user.userId,
                            domProps: { value: user.userId }
                          },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(user.userName) +
                                "\n                  "
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c("label", [_vm._v("シフト")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedShiftId,
                        expression: "selectedShiftId"
                      }
                    ],
                    staticClass: "search-select custom-select",
                    attrs: { name: "shiftId" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedShiftId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [_vm._v("なし")]),
                    _vm._v(" "),
                    _vm._l(_vm.shiftList, function(shift) {
                      return _c(
                        "option",
                        { key: shift.id, domProps: { value: shift.id } },
                        [
                          _vm._v(
                            "\n                      " +
                              _vm._s(shift.name) +
                              "\n                  "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "/api/work/download/excel/" +
                        _vm.selectedYear +
                        "/" +
                        _vm.selectedMonth +
                        "/" +
                        _vm.selectedUserId +
                        "?interval=" +
                        _vm.selectedInterval +
                        "&shiftId=" +
                        _vm.selectedShiftId
                    }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "/api/work/download/pdf/" +
                        _vm.selectedYear +
                        "/" +
                        _vm.selectedMonth +
                        "/" +
                        _vm.selectedUserId +
                        "?interval=" +
                        _vm.selectedInterval +
                        "&shiftId=" +
                        _vm.selectedShiftId
                    }
                  },
                  [_vm._m(1)]
                ),
                _vm._v(" "),
                _vm.isExistsUpload === true
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/api/work/timetable/upload/" +
                            _vm.selectedYear +
                            "/" +
                            _vm.selectedMonth +
                            "/" +
                            _vm.selectedUserId
                        }
                      },
                      [_vm._m(2)]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3" }, [
                  _vm.isExistsUpload === true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-danger m-1",
                          staticStyle: { "border-radius": "50px" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.deleteAttachment($event)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-trash" }),
                          _vm._v(
                            "\n                      添付削除\n                  "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isExistsUpload === false
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-dark m-1",
                          staticStyle: { "border-radius": "50px" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.clickShowAttachment($event)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa",
                            class: {
                              "fa-chevron-circle-right": !_vm.showAttachment,
                              "fa-chevron-circle-left": _vm.showAttachment
                            }
                          }),
                          _vm._v(
                            "\n                      勤務表アップロード\n                  "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isExistsUpload === false && _vm.showAttachment === true
                    ? _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.upload($event)
                            }
                          }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "file",
                              name: "file",
                              id: "uploadFile"
                            },
                            on: { change: _vm.selectedFile }
                          }),
                          _vm._v(" "),
                          _vm.uploadFile
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-info",
                                  attrs: { type: "submit" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-cloud-upload fa-1x",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v("アップロード\n                      ")
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.workTimetable
                ? _c("div", { staticClass: "row" }, [
                    _c("h3", { staticClass: "col-md-4 pt-1" }, [
                      _vm._v("合計勤務時間 "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.workTimetable.workHourSum))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.workTimetable.confirmCount +
                      _vm.workTimetable.remandRequestCount +
                      _vm.workTimetable.approvedCount !=
                    0
                      ? _c("div", { staticClass: "ml-3" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-default btn-outline-dark",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#remand"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-reply fa-1x",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v("差し戻し\n                  ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "modal fade",
                              attrs: {
                                id: "remand",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "remandLabel",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog modal-lg",
                                  attrs: { role: "document" }
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "modal-footer" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-secondary",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal"
                                          }
                                        },
                                        [_vm._v("キャンセル")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-warning",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updateStatus("remand")
                                            }
                                          }
                                        },
                                        [_vm._v("差し戻し")]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.workTimetable.approvedCount < _vm.workTimetable.days
                      ? _c("div", { staticClass: "ml-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-raised btn-success",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#workConfirm"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-check fa-1x",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v("承認\n                  ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "modal fade",
                              attrs: {
                                id: "workConfirm",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "workConfirmLabel",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog modal-lg",
                                  attrs: { role: "document" }
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _vm._m(5),
                                    _vm._v(" "),
                                    _vm._m(6),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "modal-footer" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-secondary",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal"
                                          }
                                        },
                                        [_vm._v("キャンセル")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-success",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.updateStatus(
                                                "approved"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("承認")]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.workList.length == 0
                ? _c("div")
                : _c("div", { staticStyle: { overflow: "scroll" } }, [
                    _c(
                      "table",
                      { staticClass: "table table-sm table-bordered" },
                      [
                        _c("thead", { staticClass: "thead-light" }, [
                          _c("tr", [
                            _c("th", [_vm._v("日付")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("曜日")]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("clockIn")
                                  }
                                }
                              },
                              [_vm._v("出勤")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("clockOut")
                                  }
                                }
                              },
                              [_vm._v("退勤")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("breakTime")
                                  }
                                }
                              },
                              [_vm._v("休憩")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("otherBreakTime")
                                  }
                                }
                              },
                              [_vm._v("その他休憩")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("midnightBreakTime")
                                  }
                                }
                              },
                              [_vm._v("深夜帯休憩")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("fixedTime")
                                  }
                                }
                              },
                              [_vm._v("所定内勤務")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("overTime")
                                  }
                                }
                              },
                              [_vm._v("所定外勤務")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("midnightTime")
                                  }
                                }
                              },
                              [_vm._v("深夜勤務")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.highlight("workTime")
                                  }
                                }
                              },
                              [_vm._v("合計時間")]
                            ),
                            _vm._v(" "),
                            _c("th", [_vm._v("休暇種類")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("勤務形態")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("備考")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("修正履歴")]),
                            _vm._v(" "),
                            _c("th", [
                              _vm.workTimetable.approvedCount ==
                              _vm.workTimetable.days
                                ? _c("span", [_vm._v("ステータス")])
                                : _vm.workTimetable.confirmCount ==
                                  _vm.workTimetable.days
                                ? _c("span", [_vm._v("ステータス")])
                                : _vm.workTimetable.remandRequestCount ==
                                  _vm.workTimetable.days
                                ? _c("span", [_vm._v("ステータス")])
                                : _c("span", [_vm._v("修正")])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.workList, function(result) {
                            return _c(
                              "tr",
                              {
                                key: result.targetDate,
                                class: { "work-highlight": result.hover },
                                on: {
                                  mouseover: function($event) {
                                    result.hover = true
                                    _vm.$forceUpdate()
                                  },
                                  mouseleave: function($event) {
                                    result.hover = false
                                    _vm.$forceUpdate()
                                  }
                                }
                              },
                              [
                                _c("td", [
                                  result.dayOfWeek === "土"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "blue" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("date")(result.targetDate)
                                            )
                                          )
                                        ]
                                      )
                                    : result.dayOfWeek === "日" ||
                                      _vm.isHoliday(result.targetDate)
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("date")(result.targetDate)
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date")(result.targetDate)
                                          )
                                        )
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  result.dayOfWeek === "土"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "blue" } },
                                        [_vm._v(_vm._s(result.dayOfWeek))]
                                      )
                                    : result.dayOfWeek === "日" ||
                                      _vm.isHoliday(result.targetDate)
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v(_vm._s(result.dayOfWeek))]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(result.dayOfWeek))
                                      ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config.highlightTimeTableClockIn ==
                                        1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("time")(result.clockIn)
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          result.late
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-warning",
                                                  staticStyle: { color: "#555" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement": "top",
                                                        "data-html": "true",
                                                        title:
                                                          "シフト開始時刻は" +
                                                          _vm.workTimetable
                                                            .shiftStartHour +
                                                          "です"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                      遅刻\n                                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config.highlightTimeTableClockOut ==
                                        1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("time")(result.clockOut)
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          result.leaveEarly
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-info"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement": "top",
                                                        "data-html": "true",
                                                        title:
                                                          "シフト終了時刻は" +
                                                          _vm.workTimetable
                                                            .shiftEndHour +
                                                          "です"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                      早退\n                                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config
                                          .highlightTimeTableBreakTime == 1
                                    }
                                  },
                                  [
                                    result.dayOff < 2 &&
                                    result.clockIn != null &&
                                    result.clockOut != null
                                      ? _c("span", [
                                          _c("span", [
                                            _vm._v(_vm._s(result.breakTime))
                                          ]),
                                          _vm._v(" "),
                                          (result.officeTimeMin > 360 &&
                                            result.breakTimeMin < 45) ||
                                          (result.officeTimeMin > 480 &&
                                            result.breakTimeMin < 60) ||
                                          (result.sumWorkTimeMin == 0 &&
                                            result.breakTimeMin > 0)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-danger"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement": "top",
                                                        "data-html": "true",
                                                        title:
                                                          "次のいずれかが該当しています。ご確認ください。\n                                      (1) 6時間勤務以上で休憩が45分未満\n                                      (2) 8時間勤務以上で休憩が60分未満\n                                      (3) 勤務時間なしで、休憩あり"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                      確認\n                                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config
                                          .highlightTimeTableOtherBreakTime == 1
                                    }
                                  },
                                  [
                                    result.dayOff < 2 &&
                                    result.clockIn != null &&
                                    result.clockOut != null
                                      ? _c("span", [
                                          _vm._v(_vm._s(result.otherBreakTime))
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config
                                          .highlightTimeTableMidnightBreakTime ==
                                        1
                                    }
                                  },
                                  [
                                    result.dayOff < 2 &&
                                    result.clockIn != null &&
                                    result.clockOut != null
                                      ? _c("span", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(result.midnightBreakTime)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          result.midnightTimeMin == 0 &&
                                          result.midnightBreakTimeMin > 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-danger"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement": "top",
                                                        "data-html": "true",
                                                        title:
                                                          "深夜勤務なしで、深夜帯休憩があります。ご確認ください"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                      確認\n                                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config
                                          .highlightTimeTableFixedTime == 1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _vm._v(_vm._s(result.fixedWorkHour))
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config.highlightTimeTableOverTime ==
                                        1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _vm._v(_vm._s(result.overWorkHour))
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config
                                          .highlightTimeTableMidnightTime == 1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(result.midnightWorkHour)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      highlight:
                                        _vm.config.highlightTimeTableWorkTime ==
                                        1
                                    }
                                  },
                                  [
                                    result.dayOff < 2
                                      ? _c("span", [
                                          _vm._v(_vm._s(result.sumWorkHour))
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "noflap",
                                    staticStyle: {
                                      "text-align": "center",
                                      "vertical-align": "middle"
                                    }
                                  },
                                  [
                                    result.dayOff == 0 ? _c("span") : _vm._e(),
                                    _vm._v(" "),
                                    result.dayOff == 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                              半休\n                                  "
                                          ),
                                          result.hasLeaveRequest
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                  有給\n                                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    result.dayOff == 2
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                              全休\n                                  "
                                          ),
                                          result.hasLeaveRequest
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                  有給\n                                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    result.dayOff == 3
                                      ? _c("span", [
                                          _vm._v("特別休暇"),
                                          _c("br"),
                                          _vm._v(
                                            "(" +
                                              _vm._s(result.specialLeaveName) +
                                              ")"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    result.dayOff == 4
                                      ? _c("span", [_vm._v("代休")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    result.dayOff == 5
                                      ? _c("span", [_vm._v("その他 諸定休暇")])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "noflap",
                                    staticStyle: { "font-size": "0.7rem" }
                                  },
                                  [_vm._v(_vm._s(result.workStyle))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "noflap",
                                    staticStyle: { "font-size": "0.7rem" }
                                  },
                                  [_vm._v(_vm._s(result.note))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-0 pb-0",
                                    staticStyle: {
                                      "text-align": "center",
                                      "vertical-align": "middle"
                                    }
                                  },
                                  [
                                    result.edited == 0
                                      ? _c("span")
                                      : 1
                                      ? _c("span", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-raised btn-info btn-sm",
                                              attrs: {
                                                "data-toggle": "modal",
                                                "data-target":
                                                  "#" +
                                                  result.userId +
                                                  result.targetDate
                                              }
                                            },
                                            [_vm._v("履歴")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "modal fade",
                                              attrs: {
                                                id:
                                                  result.userId +
                                                  result.targetDate,
                                                tabindex: "-1",
                                                role: "dialog",
                                                "aria-labelledby":
                                                  "exampleModal3Label",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "modal-dialog modal-lg",
                                                  attrs: { role: "document" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "modal-content"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "modal-header"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "modal-title",
                                                              attrs: {
                                                                id:
                                                                  "exampleModal3Label"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                 " +
                                                                  _vm._s(
                                                                    result.targetDate
                                                                  ) +
                                                                  "の編集履歴\n                                              "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._m(7, true)
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "modal-body"
                                                        },
                                                        [
                                                          _c(
                                                            "table",
                                                            {
                                                              staticClass:
                                                                "table table-bordered table-responsive"
                                                            },
                                                            [
                                                              _vm._m(8, true),
                                                              _vm._v(" "),
                                                              _c(
                                                                "tbody",
                                                                _vm._l(
                                                                  result.workChangelogList,
                                                                  function(
                                                                    log,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "tr",
                                                                      {
                                                                        key: index
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "datetime"
                                                                                )(
                                                                                  log.modifiedDate
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.modifiedUserName
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "datetime"
                                                                                )(
                                                                                  log.clockIn
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "datetime"
                                                                                )(
                                                                                  log.clockOut
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.breakTimeMin
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.otherBreakTimeMin
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.midnightBreakTimeMin
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.edited
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            log.dayOff ==
                                                                            0
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "なし"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            log.dayOff ==
                                                                            1
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "半休"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            log.dayOff ==
                                                                            2
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "全休"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            log.dayOff ==
                                                                            3
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "特別休暇"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            log.dayOff ==
                                                                            4
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "代休"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            log.dayOff ==
                                                                            5
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "その他 諸定休暇"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.earlyShift
                                                                                  ? "早出"
                                                                                  : ""
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.workStyle
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.note
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-0 pb-0 noflap",
                                    on: {
                                      mouseenter: function($event) {
                                        return _vm.tooltip(
                                          result.status,
                                          $event
                                        )
                                      },
                                      mouseleave: _vm.closeTooltip
                                    }
                                  },
                                  [
                                    result.status === "確定"
                                      ? _c(
                                          "span",
                                          { staticClass: "square_btn1" },
                                          [_vm._v("確定")]
                                        )
                                      : result.status === "承認済み"
                                      ? _c(
                                          "span",
                                          { staticClass: "square_btn" },
                                          [_vm._v("承認")]
                                        )
                                      : result.status === "差し戻し依頼"
                                      ? _c(
                                          "span",
                                          { staticClass: "square_btn2" },
                                          [_vm._v("差戻し依頼")]
                                        )
                                      : _c("span", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-default btn-sm btn-outline-info",
                                              on: {
                                                click: function($event) {
                                                  return _vm.goEdit(
                                                    result.targetDate
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("修正")]
                                          )
                                        ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info",
        staticStyle: { "border-radius": "50px" },
        attrs: { type: "button" }
      },
      [
        _c("i", {
          staticClass: "fas fa-cloud-download-alt fa-1x",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("Excel\n                  ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info",
        staticStyle: { "border-radius": "50px" },
        attrs: { type: "button" }
      },
      [
        _c("i", {
          staticClass: "fas fa-cloud-download-alt fa-1x",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("PDF\n                  ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info",
        staticStyle: { "border-radius": "50px" },
        attrs: { type: "button" }
      },
      [
        _c("i", {
          staticClass: "fa fa-paperclip fa-1x",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("添付\n                      ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title", attrs: { id: "remandLabel" } }, [
        _vm._v("確認")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [_vm._v("以下を確認ください")]),
      _vm._v(" "),
      _c("p", [_vm._v("・ユーザは勤怠編集可能になります")]),
      _vm._v(" "),
      _c("p", [_vm._v("・ユーザに通知します")]),
      _vm._v(" "),
      _c("p", [_vm._v("本当に差し戻しますか？")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "workConfirmLabel" } },
        [_vm._v("確認")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [_vm._v("以下を確認ください")]),
      _vm._v(" "),
      _c("p", [_vm._v("・承認後も差し戻し可能です")]),
      _vm._v(" "),
      _c("p", [_vm._v("・ユーザに通知します")]),
      _vm._v(" "),
      _c("p", [_vm._v("本当に承認してよろしいですか？")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("更新日時")]),
        _vm._v(" "),
        _c("th", [_vm._v("更新者")]),
        _vm._v(" "),
        _c("th", [_vm._v("出勤")]),
        _vm._v(" "),
        _c("th", [_vm._v("退勤")]),
        _vm._v(" "),
        _c("th", [_vm._v("休憩（分）")]),
        _vm._v(" "),
        _c("th", [_vm._v("その他休憩（分）")]),
        _vm._v(" "),
        _c("th", [_vm._v("深夜帯休憩（分）")]),
        _vm._v(" "),
        _c("th", [_vm._v("修正フラグ")]),
        _vm._v(" "),
        _c("th", [_vm._v("休暇タイプ")]),
        _vm._v(" "),
        _c("th", [_vm._v("早出フラグ")]),
        _vm._v(" "),
        _c("th", [_vm._v("勤務形態")]),
        _vm._v(" "),
        _c("th", [_vm._v("備考")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f690298c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f690298c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/work/WorkDetail.vue
// module id = 450
// module chunks = 0